<template>
  <div class="lists-overview">
    <v-list v-if="items.length > 0">
      <v-list-tile
        ripple
        v-for="item in items"
        :key="item.id"
        @click="setCurrentList(item.id)">
        <v-list-tile-content>
          <v-list-tile-title v-text="item.name"/>
        </v-list-tile-content>
        <v-list-tile-action @click="removeItem(item.id)">
          <v-icon color="grey lighten-1">{{ tileActionIcon }}</v-icon>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>

    <!-- <v-list v-if="items.length > 0">
      <list-item v-for="item in items" :key="item.id" :item="item" type="category"/>
    </v-list> -->

    <p v-else>Je hebt nog geen lijsten gemaakt. Maak een aan door op de plus rechts onderin te drukken.</p>
  </div>
</template>

<script>
  export default {
    name: 'lists-overview',
    computed: {
      items () {
        return this.$store.getters.getLists
      },
      tileActionIcon () {
        return this.$store.getters.getEditMode ? 'close' : 'arrow_forward'
      }
    },
    methods: {
      setCurrentList (listId) {
        if (!this.$store.getters.getEditMode) {
          this.$store.commit('SET_NAV_DIRECTION', 'forward')
          this.$store.dispatch('setCurrentList', listId)
          this.$router.push({name: 'list', params: {id: listId}})
        }
      },
      removeItem (id) {
        if (this.$store.getters.getEditMode) {
          this.$store.commit('REMOVE_LIST', id)
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
  p {
    padding: 20px;
    font-size: 24px;
    text-align: center;
    em {
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// ListsOverview.vue?c2abcaaa